export const blogData = [
    {
        id: 1,
        title: 'Git & GitHub - Save, Track & Share Code',
        description: 'Learn how developers save, track, and collaborate on code using Git and GitHub — explained in simple, beginner-friendly language.',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1746546239268/f2a40592-ed4b-4a48-9266-6b4bdf0634a4.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://blog.ms-dev.me/begin-git'
    },
    {
        id: 2,
        title: 'Tech Jargon',
        description: 'Confused by tech terms? This blog breaks down complicated concepts into easy-to-understand language, helping you feel more confident in the tech world.',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1747811723949/a56c8fc7-c8eb-42fb-8b6c-6c1faae94165.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://blog.ms-dev.me/tech-jargon'
    },
    {
        id: 3,
        title: 'IP Address & DNS',
        description: 'Understand how your device finds websites on the internet using IP addresses and DNS. No tech background needed — just simple explanations with real-world examples.',
        image: 'https://cdn.hashnode.com/res/hashnode/image/upload/v1747677016758/309d69d0-d13e-4f49-b9ee-15ea85c4d4ca.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
        url: 'https://blog.ms-dev.me/ip-dns'
    },
    // {
    //     id: 4,
    //     title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
    //     description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
    //     date: 'Sep 17, 2020',
    //     image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
    //     url: 'https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html'
    // },
    // {
    //     id: 5,
    //     title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
    //     description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
    //     date: 'Oct 1, 2020',
    //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
    //     url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
    // },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/